import { useApi } from './index';

// Floor Ladder
export const useFloorLadder = (limit = 50) => {
  return useApi(`/listings/floor/ladder?limit=${limit}`);
};

// Floor Depth
export const useFloorDepth = (pct = '5,10,20') => {
  return useApi(`/listings/floor/depth?pct=${pct}`);
};


// Listings Age Stats
export const useListingsAgeStats = () => {
  return useApi('/listings/age-stats');
};

// Active Listings
export const useActiveListings = (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.sort) queryParams.append('sort', params.sort);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.cursor) queryParams.append('cursor', params.cursor);
  if (params.marketplace) queryParams.append('marketplace', params.marketplace);
  if (params.seller) queryParams.append('seller', params.seller);
  
  const queryString = queryParams.toString();
  return useApi(`/listings/active${queryString ? `?${queryString}` : ''}`);
};
